export const MEDIA_CONTENTS = [
  {
    title: 'dYdX v4 Governance Guide',
    imgURL: 'https://miro.medium.com/v2/resize:fit:1200/1*Re1-U73HLIoZiN23zQ7G5w.png',
    url: 'https://medium.com/cosmostation/dydx-v4-governance-guide-3665b0db795e',
    tag: 'GOVERNANCE GUIDE',
    date: 'Nov 27 2023',
  },
  {
    title: 'DYDX V4 Governance Voting Guide with Metamask',
    imgURL: 'https://i.ytimg.com/vi/onAZD3gC8kY/hqdefault.jpg?sqp=-oaymwEcCNACELwBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLB_zXhWKllaROedwtC1zSAZgpD11A',
    url: 'https://www.youtube.com/watch?v=onAZD3gC8kY',
    tag: 'GOVERNANCE GUIDE',
    date: 'Nov 27 2023',
    playTime: '1:11',
  },
  {
    title: 'An Introduction to dYdX’s New Fully Sovereign Blockchain',
    imgURL: 'https://miro.medium.com/v2/resize:fit:1200/1*RZnZPKWMjcZIq9Iv1gsDSg.png',
    url: 'https://medium.com/cosmostation/an-introduction-to-dydxs-new-fully-sovereign-blockchain-fe9e313058e2',
    tag: 'STAKING GUIDE',
    date: 'Nov 21 2023',
  },
  {
    title: 'dYdX Wallet Migration Guide — How to Manage Your DYDX Tokens',
    imgURL: 'https://miro.medium.com/v2/resize:fit:1200/1*Jp4maQPHS2c2N03i7aEYbA.png',
    url: 'https://medium.com/cosmostation/dydx-wallet-migration-guide-how-to-manage-your-dydx-tokens-43982ffddfb5',
    tag: 'WALLET GUIDE',
    date: 'Nov 3 2023',
  },
  {
    title: 'DYDX Bridging and Staking Guide with Metamask',
    imgURL: 'https://i.ytimg.com/vi/ENzMV5TkmtY/hqdefault.jpg?sqp=-oaymwEcCNACELwBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLAe6wRY10wWD5Z6xEhMOB4FbdeZow',
    url: 'https://www.youtube.com/watch?v=ENzMV5TkmtY',
    tag: 'BRIDGE GUIDE',
    date: 'Oct 31 2023',
    playTime: '2:03',
  },
  {
    title: 'DYDX Migration Guide',
    imgURL: 'https://miro.medium.com/v2/resize:fit:1200/1*vhVqqgV3jIfaEWya5LphUA.png',
    url: 'https://medium.com/cosmostation/dydx-migration-guide-2af37f95def5',
    tag: 'BRIDGE GUIDE',
    date: 'Oct 31 2023',
  },
  {
    title: 'The dYdX Chain Explorer, Mintscan',
    imgURL: 'https://miro.medium.com/v2/resize:fit:1200/1*RBtrZ9D-qTloU8iiRyUh4Q.png',
    url: 'https://medium.com/cosmostation/the-dydx-chain-explorer-mintscan-34d2bbbbc6dd',
    tag: 'MINTSCAN GUIDE',
    date: 'Oct 27 2023',
  },
  {
    title: 'Cosmostation Friends in Paris [dYdX, Paul]',
    imgURL: 'https://i.ytimg.com/vi/7ekllRR2600/hqdefault.jpg?sqp=-oaymwEcCNACELwBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLDx1HiwMTA4rt_WNxyGL3g5yRXEdA',
    url: 'https://www.youtube.com/watch?v=7ekllRR2600',
    tag: 'INTERVIEW',
    date: 'Aug 23 2023',
    playTime: '9:49',
  },
];
